import React, { useEffect, useState } from 'react';
import './HeroSection.css';
import Prism from '../components/Prism';
import truck from '../assets/hero-truck.png';
import CardNav from '../components/CardNav';
import logo from '../assets/sweet-justice-logo.svg';
import RequestFormModal from '../components/RequestFormModal';

export default function HeroSection() {
  const [requestOpen, setRequestOpen] = useState(false);
  const [requestRemountKey, setRequestRemountKey] = useState(0);
  // WordPress REST endpoint (make sure the WP plugin is installed on this domain)
  const REQUEST_ENDPOINT = 'https://goldlawsweetjustice.com/wp-json/sj/v1/request';
  
  // Allow global triggers (e.g., footer link) to open the request modal
  useEffect(() => {
    const handler = () => {
      try { window.dispatchEvent(new Event('sj-reset-request')); } catch (_e) {}
      setRequestOpen(true);
    };
    window.onRequestClick = handler;
    return () => { if (window.onRequestClick === handler) window.onRequestClick = undefined; };
  }, []);

  // Also listen for a custom event to open the request modal
  useEffect(() => {
    const onEvt = () => {
      try { window.dispatchEvent(new Event('sj-reset-request')); } catch (_e) {}
      setRequestOpen(true);
    };
    window.addEventListener('sj-open-request', onEvt);
    return () => window.removeEventListener('sj-open-request', onEvt);
  }, []);

  // Listen for Start Over to force a fresh mount of RequestFormModal
  useEffect(() => {
    const onStartOver = () => {
      try { window.dispatchEvent(new Event('sj-reset-request')); } catch (_e) {}
      setRequestRemountKey((k) => k + 1);
      setRequestOpen(true);
    };
    window.addEventListener('sj-start-over', onStartOver);
    return () => window.removeEventListener('sj-start-over', onStartOver);
  }, []);
  const items = [
    {
      label: 'Request Sweet Justice',
      bgColor: 'rgb(0, 0, 254)',
      textColor: '#fff',
      links: [],
    },
    {
      label: 'Sign The Waiver',
      bgColor: 'var(--ice)',
      textColor: 'var(--navy)',
      links: [],
    },
  ];
  return (
    <section className="section hero-section" id="hero">
      <div className="hero-cardnav-wrap">
        <CardNav
          key={requestOpen ? 'nav-open' : 'nav-closed'}
          logo={logo}
          logoAlt="Sweet Justice Logo"
          items={items}
          baseColor="#fff"
          menuColor="#000"
          buttonBgColor="#0000fe"
          buttonTextColor="#fff"
          ease="power3.out"
          resetKey={requestOpen ? 'open' : 'closed'}
          onCtaClick={() => {
            // Force start at Step 1 (Request Form)
            setRequestOpen(true);
          }}
          onItemLinkClick={(item, link) => {
            if (item.label === 'Request Sweet Justice' && link.label === 'Request Now') {
              setRequestOpen(true);
              return false; // prevent default navigation
            }
            return true;
          }}
        />
      </div>
      
      <div className="hero-static-background hero-bg-desktop" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0
      }}>
        <picture>
          <source media="(max-width: 768px)" srcSet={process.env.PUBLIC_URL + '/sj-hero-mobile.png'} />
          <img 
            src={process.env.PUBLIC_URL + '/sj-hero-desktop.webp'} 
            alt="Where is Sweet Justice?" 
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </picture>
      </div>

      <RequestFormModal
        key={`rfm-${requestRemountKey}`}
        open={requestOpen}
        onClose={() => setRequestOpen(false)}
        endpoint={REQUEST_ENDPOINT}
        onSuccess={() => {
          try { setRequestOpen(false); } catch (_e) {}
          // Automatically open the waiver modal after request is submitted
          setTimeout(() => {
            try { window.dispatchEvent(new Event('sj-open-waiver')); } catch (_e) {}
          }, 300);
        }}
      />
    </section>
  );
}

